export default {
    getSuppressErrorValue (getter, defaultValue = null) {
      try {
        return getter()
      } catch {
        return defaultValue
      }
    },
  
    suppress (action) {
      this.getSuppressErrorValue(action)
    },

    getMonth(date, monthCase = 0) {
      const months = [
        ["январь", "январе"],
        ["февраль", "феврале"],
        ["март", "марте"],
        ["апрель", "апреле"],
        ["май", "мае"],
        ["июнь", "июне"],
        ["июль", "июле"],
        ["август", "августе"],
        ["сентябрь", "сентябре"],
        ["октябрь", "октябре"],
        ["ноябрь", "ноябре"],
        ["декабрь", "декабре"]
      ]

      const month =
        (date.getMonth() < 8 ? "0" : "") + (date.getMonth() + 1).toString();
      const name = months[date.getMonth()][monthCase];
      return {
        date: `01.${month}.${date.getFullYear().toString()} г.`,
        month: name,
      };
    },
}